// material-ui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useColorScheme } from '@mui/material/styles';

// project imports
import { Logo, WhiteLogo } from '@/assets';
import { ThemeMode } from '@/theme/config';

// ==============================|| LOGO - MAIN (BRAND OFICIAL CITYZEN) ||============================== //
// Marca OFICIALĂ CityZen (aceeași ca pe site / aplicația mobilă) în locul pătratului
// generat cu gradient; sub titlul CITYZEN stă sloganul aplicației („Împreună, pentru
// noi."). Varianta albă (SVG) pe dark mode, cea color (PNG) pe light; raport păstrat.

export default function LogoMain() {
	const { colorScheme } = useColorScheme();
	const isDark = colorScheme === ThemeMode.DARK;
	return (
		<Stack direction="row" sx={{ alignItems: 'center', gap: 1.25, flexWrap: 'nowrap' }}>
			<Box
				component="img"
				src={isDark ? WhiteLogo : Logo}
				alt="CityZen"
				sx={{ height: 38, width: 'auto', flexShrink: 0, objectFit: 'contain' }}
			/>
			<Box sx={{ minWidth: 0 }}>
				<Typography
					variant="caption"
					sx={{
						display: 'block',
						fontWeight: 700,
						letterSpacing: '0.08em',
						textTransform: 'uppercase',
						color: 'primary.main',
						lineHeight: 1.2
					}}
				>
					CityZen
				</Typography>
				<Typography
					variant="body2"
					sx={{ fontWeight: 500, color: 'text.secondary', lineHeight: 1.2 }}
				>
					Împreună, pentru noi.
				</Typography>
			</Box>
		</Stack>
	);
}
